import React from 'react';

import type {
  QuestionComponentProps
} from '../shared/QuestionComponent/QuestionComponent.react';
import {
  QuestionComponent
} from '../shared/QuestionComponent/QuestionComponent.react';

import TwoWayInputArea from './TwoWayInputArea.react';

const TwoWayQuestionComponent = (props: QuestionComponentProps) => {
  return <QuestionComponent {...props} ActiveQuestionInputArea={TwoWayInputArea} />;
};

type TwoWayQuestionTypeProps = Omit<QuestionComponentProps, 'questionState'>;

const TwoWayQuestion = {
  PreGuess: (props: TwoWayQuestionTypeProps) => (
    <TwoWayQuestionComponent {...props} questionState='PreGuess' />
  ),
  PostGuess: (props: TwoWayQuestionTypeProps) => (
    <TwoWayQuestionComponent {...props} questionState='PostGuess' />
  ),
  Dennis: (props: TwoWayQuestionTypeProps) => (
    <TwoWayQuestionComponent {...props} questionState='Dennis' />
  )
};

export {TwoWayQuestion};
